export default {
	app: {
		brand_zh: 'Ulucu',
		brand_en: 'ULUCU',
	},
	common: {
		todo_module: 'الوحدة قيد التطوير ولم يتم تنفيذها بعد',
		loading: 'جارٍ التحميل…',
		no_data: 'لا توجد بيانات',
		select_store: 'اختر المتجر',
		show_raw: 'عرض الاستجابة الأصلية',
		reload: 'إعادة تحميل',
		filter: 'تصفية',
		cancel: 'إلغاء',
		back: 'رجوع',
	},
	group: {
		core: 'الأساسي',
		major: 'الرئيسي',
		support: 'الدعم',
		value_add: 'إضافات',
	},
	tabbar: {
		monitor: 'المراقبة',
		home: 'الرئيسية',
		store: 'المتاجر',
		application: 'التطبيقات',
		incidents: 'الحوادث',
		analytics: 'التحليلات',
		operations: 'التشغيل',
		account: 'الحساب',
		video: 'فيديو',
		reports: 'تقارير',
		workbench: 'مهام',
		messages: 'رسائل',
		profile: 'حسابي',
		messages_title: 'مركز الرسائل',
		reports_title: 'تحليل العملاء',
	},
	ops: {
		title: 'التشغيل',
		subtitle: 'جولات المتاجر والتفتيش الذكي وسير عمل الأجهزة',
		available: 'متاح',
		permission_required: 'يتطلب تفعيلًا',
		empty: 'لا توجد أدوات متاحة',
		view_status: 'عرض الحالة',
	},
	capability: {
		available_short: 'متاح في هذه المنطقة',
		permission_required_short: 'يتطلب تفعيل المسؤول',
		unknown_short: 'تغطية API قيد التأكيد',
		region_unavailable_short: 'غير متاح في هذه المنطقة',
		permission_required_desc: 'ليست لديك صلاحية استخدام هذه الوحدة. رسالة التطبيق الأصلي: You do not have the right to this module.',
		unknown_desc: 'هذه الإمكانية في APAC/Mexico تحتاج إلى تحقق API قبل إتاحتها للمستخدمين.',
		region_unavailable_desc: 'هذه الإمكانية تخص نشر الصين ولا ينبغي إظهارها في APAC/Mexico.',
		back_to_operations: 'العودة إلى التشغيل',
	},
	root: {
		monitor: {
			subtitle: 'فيديو المتاجر وحالة الأجهزة والعرض المتعدد',
			store_count: 'المتاجر',
			online_devices: 'أجهزة متصلة',
			offline_devices: 'أجهزة غير متصلة',
			favorites: 'المفضلة',
			tools: 'أدوات المراقبة',
			stores: 'المتاجر والقنوات',
			offline_action: 'عرض المتاجر غير المتصلة',
			offline_filter_active: 'تصفية غير المتصلة',
			tool_store: 'إدارة المتاجر',
			tool_store_hint: 'مراجعة بيانات المتاجر والمجموعات والحالة التشغيلية',
			tool_device: 'حالة الأجهزة',
			tool_device_hint: 'فحص اتصال الأجهزة وحالة القنوات',
			tool_multi_view: 'عرض متعدد',
			tool_multi_view_hint: 'اختر متجرًا قبل فتح العرض متعدد القنوات',
			tool_multi_view_empty: 'لا توجد متاجر متاحة',
			multi_view_select_store: 'اختر المتجر',
			multi_view_store_count: '{{online}}/{{total}} متصل',
			multi_view_no_online: 'لا توجد قنوات متصلة',
		},
		analytics: {
			subtitle: 'حركة العملاء والأعضاء والمركبات ومؤشرات الأعمال',
			visible_modules: 'الوحدات الظاهرة',
			primary_period: 'الفترة الرئيسية',
			trend_period: 'فترة الاتجاه',
			currency: 'العملة',
			tools: 'أدوات التحليلات',
			insights: 'ملخص الرؤى',
		},
		incidents: {
			subtitle: 'الحوادث المعلقة والتنبيهات ورسائل المتاجر',
			pending: 'الحوادث المعلقة',
			pending_hint: 'تحتاج إلى متابعة',
			today: 'حوادث اليوم',
			today_hint: 'إجمالي اليوم',
			alerts: 'التنبيهات',
			alerts_hint: 'مخاطر وتنبيهات شذوذ',
			visible_types: 'أنواع الرسائل',
			unread: 'غير مقروءة',
			loaded: 'تم التحميل',
			status: 'الحالة',
			live: 'مباشر',
			tools: 'أدوات الحوادث',
			workflow: 'الإجراءات الرئيسية',
			status_overview: 'حالة الحوادث',
			recent_messages: 'الرسائل الأخيرة',
			inbox: 'صندوق الحوادث',
			action_event: 'معالجة الحوادث',
			action_event_hint: 'مراجعة المعلقات والاعتراضات وإعادة الفحص',
			action_alert: 'مراجعة التنبيهات',
			action_alert_hint: 'تحديد المتاجر ذات المخاطر أو الشذوذ',
			action_message: 'مركز الرسائل',
			action_message_hint: 'عرض الإشعارات ورسائل النظام',
			refresh: 'تحديث ملخص الحوادث',
			updated_at: 'تم التحديث في {{time}}',
			not_updated: 'لم يتم التحديث',
			partial_data: 'بعض بيانات الحوادث غير متاحة',
			message_load_failed: 'فشل تحميل الرسائل',
			message_empty: 'لا توجد رسائل في هذا التصنيف',
		},
		account: {
			subtitle: 'المؤسسة والمنطقة واللغة والدعم',
			region: 'المنطقة',
			language: 'اللغة',
			recent_count: 'المشاهدات الأخيرة',
			support_count: 'مداخل الدعم',
			profile: 'الملف الشخصي',
			preferences: 'المنطقة واللغة',
			profile_hint: 'الاسم والهاتف والبريد والصورة',
			language_hint: 'الصينية / Español México',
			activity: 'النشاط',
			support: 'الدعم',
		},
	},
	wb: {
		evaluation: 'تقييم المتجر',
		free_patrol: 'دورية حرة',
		self_inspect: 'فحص ذاتي',
		timed_check: 'فحص مجدول',
		ai_patrol: 'دورية ذكية',
		report_audit: 'مراجعة التقارير',
		workorder: 'أوامر العمل',
		reward: 'المكافآت',
		custom: 'مخصص',
		customize: 'تخصيص',
		saved: 'تم الحفظ',
		saved_local_only: 'حُفظ محلياً (فشل المزامنة)',
		locked: 'مقفل',
		self_check: 'فحص نقطي',
		cust_analysis: 'تحليل العملاء',
		heatmap: 'الخريطة الحرارية',
		apparel: 'الأزياء',
		flow_alert: 'تنبيه التدفق',
		member_id: 'هوية العضو',
		open_store: 'متجر جديد',
		announce: 'إعلان',
		task: 'المهام',
		report_in: 'تقارير',
		staff: 'الموظفون',
		cert: 'الشهادات',
		university: 'الأكاديمية',
		huiting: 'هويتنغ',
		store_data: 'بيانات',
		pic_detect: 'كشف الصور',
		cat: {
			patrol: 'الدوريات',
			customer: 'حركة العملاء',
			enterprise: 'الأعمال',
			other: 'أخرى',
		},
		editor: {
			title: 'إدارة التطبيقات',
			cancel: 'إلغاء',
			ok: 'تم',
			hint: 'اسحب لإعادة الترتيب',
			shown: 'تطبيقات الصفحة الرئيسية',
		},
	},
	store_video: {
		tab_video: 'فيديو المتجر',
		tab_data: 'بيانات المتجر',
		store_data_unavailable: 'سيتم نسخ بيانات المتجر بشكل منفصل. تغطي هذه الصفحة قائمة فيديو المتجر فقط.',
		organization: 'المؤسسة',
		organization_all: 'كل المؤسسات',
		organization_empty: 'لا توجد بيانات مؤسسات',
		organization_failed: 'فلتر المؤسسة غير متاح: {{reason}}',
		organization_store_count: '{{count}} متاجر',
		filter: 'تصفية',
		search: 'بحث',
		search_placeholder: 'ابحث باسم المتجر أو رمزه',
		favorite_only: 'المفضلة فقط',
		summary_one: 'إجمالي {{count}} متجر، معدل الاتصال {{rate}}',
		summary: 'إجمالي {{count}} متاجر، معدل الاتصال {{rate}}',
		offline_count: 'غير متصل {{count}}',
		online_count: 'متصل {{count}}',
		total_count: 'الإجمالي {{count}}',
		created_at: 'وقت إنشاء المتجر',
		open_multi_view: 'فتح العرض المتعدد',
		sort_title: 'ترتيب',
		sort_default: 'افتراضي',
		sort_default_ranking: 'الترتيب الافتراضي',
		sort_high_to_low: 'من الأعلى إلى الأدنى',
		sort_low_to_high: 'من الأدنى إلى الأعلى',
		sort_offline: 'غير المتصل أولا',
		sort_create: 'وقت الإنشاء',
		sort_name: 'اسم المتجر',
		favorite_store_video: 'فيديو المتاجر المفضلة',
		favorite_store_data: 'بيانات المتاجر المفضلة',
		no_collection: 'لا توجد مفضلات',
		filter_data: 'البيانات',
		filter_time: 'الوقت',
		metric_entry_number: 'عدد الدخول',
		metric_total_number: 'العدد الإجمالي',
		metric_total_sales: 'إجمالي المبيعات',
		metric_ecr: 'ECR',
		metric_events: 'الأحداث',
		metric_turnover_rate: 'معدل التحويل',
		time_today: 'اليوم',
		time_yesterday: 'أمس',
		time_week: 'هذا الأسبوع',
		time_seven: 'آخر 7 أيام',
		time_month: 'هذا الشهر',
		time_thirty: 'آخر 30 يومًا',
		calling_store_manager: 'جارٍ الاتصال بمدير المتجر',
	},
	settings: {
		account: 'الحساب واللغة',
		app: 'معلومات التطبيق',
		storage: 'التخزين المحلي',
		support: 'الدعم',
		runtime: 'بيئة التشغيل',
		runtime_app: 'تطبيق الجوال',
		runtime_web: 'متصفح الويب',
		version: 'الإصدار',
		version_hint: 'إصدار حزمة الواجهة الحالي',
		clear_recent: 'مسح المشاهدات الأخيرة',
		clear_recent_hint: '{{count}} سجل مشاهدة محلي',
		clear_recent_success: 'تم مسح المشاهدات الأخيرة',
		feedback_hint: 'إرسال ملاحظة أو شكوى',
		hotline_hint: 'عرض خيارات الدعم لهذه المنطقة',
		logout: 'تسجيل الخروج',
	},
	mtab: {
		video: {
			brand_full: 'شركة Shanghai Ulucu للتكنولوجيا الإلكترونية',
			search_placeholder: 'ابحث عن متجر بالاسم أو الكود',
			filter: 'تصفية',
			tab_all: 'الكل',
			tab_fav: 'المفضلة',
			summary_one: '{{count}} متجر · معدل الاتصال: {{rate}}',
			summary: '{{count}} متجر · معدل الاتصال: {{rate}}',
			offline_count_one: '{{n}} جهاز غير متصل',
			offline_count: '{{n}} جهاز غير متصل',
			device_online: 'متصل',
			device_offline: 'غير متصل',
			all_online: 'الكل متصل',
			no_device: 'لا توجد أجهزة',
			view_all: 'عرض الكل',
		},
		msg: {
			system: 'النظام',
			event: 'الأحداث',
			examine: 'الفحوصات',
			critical: 'زوار مهمون',
			empty: 'لا توجد رسائل خلال آخر يومين',
		},
		profile: {
			guest: 'لم يتم تسجيل الدخول',
			subtitle: 'حساب تجريبي',
			album: 'ألبومي',
			recent: 'شوهد مؤخرًا',
			repair: 'إصلاح عبر الإنترنت',
			repair_log: 'سجل الإصلاح',
			hotline: 'الخط الساخن',
			feedback: 'اقتراحات',
			changelog: 'سجل التحديثات',
			settings: 'الإعدادات',
			settings_hint: 'اللغة والإصدار والتخزين وتسجيل الخروج',
			recent_empty: 'لا توجد سجلات حديثة',
			recent_view_all: 'عرض الكل',
			edit_profile: 'الملف الشخصي',
			edit_personal_data: 'تحرير البيانات الشخصية',
			name: 'الاسم',
			mobile: 'الجوال',
			mobile_phone: 'رقم الجوال',
			email: 'البريد الإلكتروني',
			email_address: 'عنوان البريد الإلكتروني',
			email_placeholder: 'أدخل المحتوى',
			edit_avatar: 'تحرير الصورة الرمزية',
			save: 'حفظ',
			save_success: 'تم الحفظ',
			save_unavailable: 'الحفظ غير متاح بعد',
			online: 'متصل',
			offline: 'غير متصل',
			hotline_label: 'الخط الساخن لخدمة العملاء',
			call: 'اتصل',
			feedback_placeholder: 'الرجاء إدخال اقتراحك أو تعليقك…',
			feedback_submit: 'إرسال',
			feedback_required: 'المحتوى مطلوب',
			feedback_success: 'شكرا لملاحظاتك',
			changelog_empty: 'لا يوجد سجل تحديثات بعد',
		},
		rep: {
			pos_input: 'إدخال POS',
			portrait: 'الملف',
			precise: 'تدفق دقيق',
			batch: 'تدفق دفعي',
			realtime: 'مباشر',
			consume: 'الإنفاق',
			distribution: 'التوزيع',
			funnel: 'القمع',
			duration: 'مدة البقاء',
			rank: 'ترتيب المتاجر',
			store_filter: '{{count}} متجر محدد',
			overview: 'نظرة عامة',
			mom: 'شهري',
			yoy: 'سنوي',
			compare_range: 'فترة المقارنة',
			pass_count: 'المارة',
			enter_count: 'الداخلون',
			enter_conv: 'نسبة الدخول',
			try_count: 'القياس',
			try_conv: 'نسبة القياس',
			member_count: 'الأعضاء',
			stay_duration: 'متوسط البقاء (د)',
			deal_conv: 'نسبة الإتمام',
			leave_count: 'الخارجون',
			invoice_count: 'المعاملات',
			amount: 'الإيرادات',
			commodity_count: 'الأصناف',
			avg_enter: 'متوسط الدخول',
			hour: 'ساعة',
			day: 'يوم',
			flow_trend: 'اتجاه التدفق',
			daily_avg: 'متوسط يومي',
			peak: 'القمة',
			valley: 'القاع',
		},
	},
	player: {
		playback: 'Playback',
		history_segment_count: '{{count}} segments',
		hd: 'عالي الدقة',
		sd: 'عادي',
		fill: 'ملء',
		fit: 'ملاءمة',
		live: 'مباشر',
		all: 'الكل',
		view_legend: 'وسيلة الإيضاح',
		no_device: 'اختر جهازًا',
		no_stream: 'لا يوجد بث',
		no_history: 'لا توجد تسجيلات لهذا اليوم',
		no_record_at_time: 'لا يوجد تسجيل في هذه اللحظة',
		playback_started: 'بدأ التشغيل',
		screenshot_done: 'تم حفظ اللقطة',
		fn_screenshot: 'لقطة',
		fn_intercom: 'محادثة',
		fn_record: 'تسجيل',
		fn_event: 'حدث جديد',
		fn_ptz: 'تحريك الكاميرا',
		fn_pos: 'بحث POS',
		fn_record_stop: 'إيقاف التسجيل',
		recording_started: 'جارٍ التسجيل…',
		recording_saved: 'تم حفظ التسجيل',
		cap_unsupported: 'الجهاز لا يدعم هذه الميزة',
		share: 'مشاركة',
		video_init_failed: 'فشل تهيئة الفيديو...',
	},
	ptz: {
		no_permission: 'لا توجد صلاحية تحريك الكاميرا، اطلب من المسؤول تفعيلها.',
	},
	rename: {
		title: 'إعادة تسمية القناة',
		placeholder: 'أدخل الاسم الجديد',
		success: 'تمت إعادة التسمية',
		failed: 'فشلت إعادة التسمية',
	},
	channel: {
		select: 'اختر القناة',
		count: '{{count}} قناة',
	},
	store_detail: {
		tab_devices: 'الأجهزة',
		tab_overview: 'نظرة عامة',
		copy: 'نسخ',
		copied: 'تم النسخ',
		copy_failed: 'فشل النسخ',
		created_at: 'تاريخ الإنشاء',
		devices_all: 'الكل',
		devices_online: 'متصلة',
		devices_offline: 'غير متصلة',
		cat_all: 'جميع الأجهزة',
		cat_camera: 'كاميرات',
		cat_audio: 'صوت',
		my_nvr_devices: 'أجهزة NVR الخاصة بي',
		multi_view: 'عرض متعدد',
		open_video: 'فتح الفيديو',
		more: 'المزيد',
		status_online: 'متصل',
		status_offline: 'غير متصل',
		offline_hint: 'الجهاز غير متصل، التشغيل غير متاح',
		offline_unplayable: 'الجهاز غير متصل، التشغيل غير متاح',
		call_owner: 'الاتصال بصاحب المتجر',
		no_phone: 'لا يوجد هاتف لهذا المتجر',
		repair_log: 'سجل الإصلاح',
		service_hotline: 'الخط الساخن للصيانة',
		delete_store: 'حذف المتجر',
		confirm_delete: 'تأكيد حذف المتجر؟',
		confirm_delete_ok: 'حذف',
		deleted: 'تم الحذف',
		delete_failed: 'فشل الحذف',
	},
	repair: {
		title: 'إصلاح عبر الإنترنت',
		store: 'المتجر',
		contact: 'جهة الاتصال',
		contact_phone: 'هاتف الاتصال',
		store_phone: 'هاتف المتجر',
		describe: 'وصف العطل',
		optional: 'اختياري',
		add_images: 'إضافة صور',
		images_tip: 'يرجى رفع صور توضح المشكلة لتسريع الحل.',
		tip: 'للحل السريع، جرب الحل المحلي أولاً قبل تقديم البلاغ.',
		submit: 'إرسال',
		contact_required: 'الرجاء إدخال جهة الاتصال',
		phone_required: 'الرجاء إدخال الهاتف',
		describe_required: 'الرجاء وصف العطل',
		success: 'تم الإرسال',
		failed: 'فشل الإرسال',
		over_limit: 'وصل هذا المتجر إلى حد طلبات الإصلاح المعلقة. يرجى معالجة السجلات الحالية قبل إرسال طلب جديد.',
		history: 'سجل الإصلاح',
	},
	hotline: {
		cn_desc: 'يمكن لحسابات الصين الاتصال مباشرة بخط خدمة العملاء.',
		local_label: 'الدعم المحلي',
		local_value: 'APAC / Mexico',
		local_desc: 'لا يستخدم مستخدمو المكسيك و APAC خط 400 الخاص بالصين. أرسل طلب دعم أو تواصل مع مدير الحساب المحلي.',
		feedback_action: 'إرسال طلب دعم',
	},
	inspect: {
		status: 'الحالة',
		overdue: 'متأخر',
		progress: 'التقدم',
	},
	patrol: {
		total_plans: 'إجمالي الخطط',
		completed: 'مكتمل',
		overdue: 'متأخر',
		completion_rate: 'معدل الإنجاز',
	},
	message: {
		unread_by_category: 'غير المقروءة حسب الفئة',
		unread: 'غير مقروء',
		recent: 'الرسائل الأخيرة',
		cat_all: 'الكل',
		cat_event: 'حدث',
		cat_alarm: 'تنبيه',
		cat_examine: 'فحص',
		cat_system: 'النظام',
		cat_share: 'مشاركة',
		cat_face: 'التعرف على الوجه',
		cat_human_alarm: 'تنبيه بشري',
		cat_shop_inspection: 'تفتيش المتجر',
		cat_detachment_detection: 'كشف مغادرة الموقع',
		cat_spot_inspection: 'مهمة فحص موضعي',
		cat_black_list: 'القائمة السوداء',
		cat_youxun_moveai: 'Youxun Move AI',
		cat_youxun_picai: 'Youxun Image AI',
		cat_pos_trade: 'معاملة POS',
		cat_youqin: 'حضور Youqin',
		cat_face_mask: 'التعرف على الكمامة',
		cat_data_warning: 'تنبيه البيانات',
		cat_take_place: 'مشغل الحدث',
		cat_youxun_advancedai: 'Youxun Advanced AI',
		cat_youxun_paidui: 'طابور Youxun',
		cat_shelf_analysis: 'تحليل الرفوف',
	},
	alert: {
		total: 'إجمالي التنبيهات',
		pending: 'معلقة',
		handled: 'تمت معالجتها',
	},
	incident_domain: {
		title: 'مساحة عمل الحوادث',
		subtitle: 'معالجة الأحداث والتنبيهات والرسائل في مكان واحد',
		partial_data: 'بعض بيانات الحوادث غير متاحة',
		alert_unread: 'تنبيهات غير مقروءة',
		message_unread: 'رسائل غير مقروءة',
		status_overview: 'نظرة عامة على حالة الأحداث',
		alert_workbench: 'معالجة التنبيهات',
		alert_note: 'تم ربط إحصاءات التنبيهات',
		alert_note_desc: 'تفاصيل التنبيهات تحتاج إلى قاموس أنواع الأحداث قبل فتحها. حالياً استخدم حالة الأحداث ورسائل التنبيه لتحديد المخاطر المعلقة.',
		message_workbench: 'معالجة الرسائل',
		no_messages: 'لا توجد رسائل في هذه الفئة',
		event_message_hint: 'لديك {{count}} رسالة حدث غير مقروءة. انتقل إلى الرسائل لمعالجتها.',
	},
	store: {
		all_stores: 'جميع المتاجر',
		groups: 'مجموعات المتاجر',
		total: 'إجمالي المتاجر',
		online: 'مفتوح',
		with_device: 'يحتوي على جهاز',
		has_device: 'يحتوي على جهاز',
		stores_in_group: 'متجر',
	},
	heatmap: {
		todo_visualization: 'تصور الخريطة الحرارية قيد التطوير',
		todo_desc: 'تم جلب البيانات الأولية (أدناه). سيتم العرض باستخدام ECharts heatmap.',
	},
	msg: {
		order_title: 'ترتيب أنواع الرسائل',
		save: 'حفظ',
		saved: 'تم الحفظ',
		available: 'أنواع متاحة',
		no_more: '— لا مزيد —',
		row_label: '{{label}}، الموضع {{position}} من {{total}}',
		remove_label: 'إزالة {{label}}',
		add_label: 'إضافة {{label}}',
		move_up_label: 'تحريك {{label}} لأعلى',
		move_down_label: 'تحريك {{label}} لأسفل',
		unread_card_label: 'رسالة غير مقروءة: {{title}}',
		status: { unread: 'غير مقروء' },
		kp: {
			arrive_time: 'وقت الوصول',
			store: 'المتجر',
			name: 'الاسم',
			sex: 'الجنس',
			male: 'ذكر',
			female: 'أنثى',
			record: 'السجل',
			arrive_n_times: 'زيارات: {{n}}',
		},
		pos: {
			fallback: 'معاملة',
			type_1: 'بيع',
			type_2: 'استرداد',
			type_3: 'شحن',
			type_4: 'تقرير خسارة',
			type_5: 'تقريب',
			type_6: 'شذوذ AI',
			type_7: 'تصحيح',
			type_8: 'إرجاع',
			type_9: 'عكس التسوية',
			type_10: 'خصم',
			type_11: 'إرجاع توصيل',
			type_12: 'رفض الطلب',
			type_13: 'إلغاء غير طبيعي',
			type_14: 'إرجاع غير طبيعي',
			type_15: 'مجاني',
		},
	},
	msg_t: {
		system: 'النظام',
		event: 'الأحداث',
		examine: 'التقييم',
		key_person: 'زوار رئيسيون',
		blacklist: 'قائمة سوداء',
		xundian: 'دورية المتجر',
		tuogang: 'غياب',
		pic_ai: 'صور AI',
		move_ai: 'فيديو AI',
		face_mask: 'بدون كمامة',
		data_warn: 'تنبيه البيانات',
		cert: 'الشهادات',
		youschool: 'الأكاديمية',
		store_build: 'متجر جديد',
		image_exception: 'صورة معطلة',
		alarm: 'إنذار',
		human_alarm: 'تنبيه بشري',
		face: 'الوجه',
		ai_tag_video: 'فيديو AI',
		pos_trade: 'POS',
		dianjian: 'فحص',
	},
	eval: {
		search_ph: 'ابحث عن المهام',
		expired_tasks: 'منتهية',
		no_active: 'لا توجد مهام نشطة',
		no_expired: 'لا توجد مهام منتهية',
		valid_time: 'الصلاحية',
		to: 'إلى',
		cycle: 'الدورة',
		frequency: 'التكرار',
		times: 'مرة',
		eval_stores: 'المتاجر',
		done_stores: 'منجزة',
		unit_store: '',
		unit_copy: 'نسخة',
		progress: 'التقدم',
		submit_count: 'مُسلّم',
		remote_eval: 'عن بعد',
		onsite_eval: 'في الموقع',
		view_report: 'التقارير',
		detail_title: 'تفاصيل المهمة',
		template: 'القالب',
		evaluators: 'المقيمون',
		recent_reports: 'تقارير حديثة',
	},
	rp: {
		tab_records: 'السجلات',
		tab_levels: 'القواعد',
		all_rp: 'الكل',
		reward: 'مكافأة',
		penalty: 'عقوبة',
		last_7d: 'آخر 7 أيام',
		last_30d: 'آخر 30 يوم',
		last_90d: 'آخر 3 أشهر',
		sort_by_create: 'حسب الإنشاء',
		add: 'إضافة',
		edit: 'تحرير',
		delete: 'حذف',
		confirm_delete: 'حذف هذه القاعدة؟',
		deleted: 'تم الحذف',
		delete_failed: 'فشل الحذف',
		edit_title: 'تحرير القاعدة',
		add_title: 'قاعدة جديدة',
		save: 'حفظ',
		saved: 'تم الحفظ',
		save_failed: 'فشل الحفظ',
		type: 'النوع',
		level_name: 'الاسم',
		level_name_ph: 'أدخل اسم القاعدة',
		amount: 'المبلغ',
		amount_ph: 'أدخل المبلغ',
		usage: 'الاستخدام',
		usage_ph: 'اشرح كيفية الاستخدام',
		title_required: 'الاسم مطلوب',
		amount_required: 'مبلغ صحيح مطلوب',
	},
	hot: {
		select_store: 'المتجر:',
		date: 'التاريخ:',
		pick_store: 'اختر متجراً أولاً',
		no_device: 'لا توجد أجهزة خريطة حرارية',
		not_configured: 'لم يتم تكوين مناطق حرارية لهذا الجهاز',
		filter_areas: 'تصفية المناطق',
		show_all: 'عرض الكل',
		hide_all: 'إخفاء الكل',
		stay_label: 'مدة التوقف:',
		seconds: '{{n}} ث',
		keliu: 'الزوار',
		stop: 'المتوقفون',
		stop_rate: 'معدل التوقف',
		avg_stay: 'متوسط البقاء',
	},
	traffic: {
		total_vehicles: 'إجمالي المركبات',
		avg_plate: 'متوسط التعرف على اللوحات',
		hourly_trend: 'اتجاه المركبات بالساعة',
	},
	leavepost: {
		no_records: 'لا توجد سجلات خارج المنصب في هذا اليوم',
		duration: 'المدة',
	},
	auth: {
		login_title: 'تسجيل الدخول',
		account: 'الحساب',
		account_required: 'يرجى إدخال الحساب',
		password: 'كلمة المرور',
		password_required: 'يرجى إدخال كلمة المرور',
		login: 'تسجيل الدخول',
		login_success: 'تم تسجيل الدخول',
		login_failed: 'فشل تسجيل الدخول',
		session_elsewhere: 'It is detected that your account has been logged in elsewhere. Please sign in again.',
		remember_account: 'تذكر الحساب',
		logout: 'تسجيل الخروج',
		logged_in_as: 'تم تسجيل الدخول باسم',
		tip_internal_dev: 'وضع التطوير — استخدام واجهة Ulucu الداخلية',
	},
	home: {
		welcome: 'مرحبا بك في Ulucu',
		intro: 'عميل إدارة المتاجر · متعدد اللغات (zh / en / es / ar)',
		store_count: 'إجمالي {{count}} متاجر',
		has_device: 'يحتوي على جهاز',
	},
	dashboard: {
		online_rate: 'معدل اتصال الأجهزة',
		device_status: 'توزيع حالة الأجهزة',
	},
	device: {
		total: 'الإجمالي',
		online: 'متصل',
		offline: 'غير متصل',
		channels: 'القنوات',
		off_time: 'غير متصل منذ',
		select_device: 'اختر الجهاز',
	},
	daterange: {
		today: 'اليوم',
		'7d': 'آخر 7 أيام',
		'30d': 'آخر 30 يوماً',
	},
	cust: {
		tab_portrait: 'الصورة',
		tab_precise:  'التدفق الدقيق',
		tab_batch:    'دفعات',
		tab_realtime: 'فوري',
		tab_consume:  'الإنفاق',
		tab_device:   'الجهاز',
		filter: 'تصفية',
		current_n_stores: '{{n}} متجر',
		overview: 'النظرة العامة',
		portrait_total: 'إجمالي الصور',
		most_portrait: 'الصورة الأكثر شيوعاً',
		unit_person: '',
		member_ratio: 'نسبة الأعضاء',
		gender_ratio: 'نسبة الجنس',
		age_ratio: 'نسبة العمر',
		age_x_gender: 'العمر × الجنس',
		age_x_identity: 'العمر × الهوية',
		member: 'عضو',
		non_member: 'غير عضو',
		male: 'ذكر',
		female: 'أنثى',
		precise_wip_title: 'التدفق الدقيق',
		precise_wip_desc: 'نظرة عامة + توزيع + قمع + بقاء + ترتيب (قيد التنفيذ)',
		mom: 'م/م',
		yoy: 'س/س',
		sub_flow: 'التوزيع',
		sub_funnel: 'القمع',
		sub_stay: 'البقاء',
		sub_rank: 'الترتيب',
		gran_hour: 'ساعة',
		gran_day: 'يوم',
		flow_trend: 'اتجاه التدفق',
		kpi: {
			pass: 'المارة',
			enter: 'الداخلون',
			enter_rate: 'معدل الدخول',
			try: 'تجربة',
			try_rate: 'معدل التجربة',
			member: 'الأعضاء',
			stay_avg: 'متوسط البقاء (د)',
			deal_rate: 'معدل الصفقة',
			bind_device: 'اربط جهازاً',
			daily_avg: 'المتوسط اليومي',
			peak: 'الذروة ({{date}})',
			valley: 'القاع ({{date}})',
		},
	},
	customer: {
		title: 'تحليل العملاء',
		date: 'التاريخ',
		pass_count: 'المارة',
		enter_count: 'الداخلون',
		unit: 'شخص',
		raw_response: 'الاستجابة الأصلية',
		hourly_trend: 'اتجاه العملاء بالساعة',
	},
	member: {
		overview: 'نظرة عامة',
		customer_list: 'العملاء',
		total: 'إجمالي الأعضاء',
		new_count: 'جدد',
		return_count: 'مكرر',
		visit_count: 'زيارة {{count}} مرة',
		last_visit: 'آخر زيارة',
		start_from: 'تاريخ البدء',
		anonymous: 'مجهول',
	},
	event: {
		range: 'النطاق',
		total: '{{count}} حدثاً',
	},
	event_count: {
		all: 'الكل',
		wait: 'قيد الانتظار',
		wait_handle: 'يحتاج إجراء',
		destroy: 'ملغاة',
		my: 'أحداثي',
		my_appeal: 'طعوني',
		appeal_audit: 'مراجعة الطعون',
		recheck: 'مراجعة',
	},
	live: {
		online_devices: 'الأجهزة',
		no_online: 'لا توجد أجهزة في هذا المتجر',
		play_live: 'البث المباشر',
		get_play_token: 'الحصول على رمز التشغيل',
		play_token_for: 'رمز التشغيل · ',
		cloud_storage: 'التخزين السحابي',
		web_limitation: 'الفيديو المباشر على الويب — الاستراتيجية',
		web_limitation_desc: 'التطبيق الحالي يستخدم بروتوكول AYClient_SDK الخاص؛ الاستراتيجية الجديدة تستخدم auth.weburl للحصول على رابط HFLV/HLS (قابل للتشغيل في المتصفح، تأخير 1-2 ثانية).',
		token_only_note: 'تم الحصول على play_token (API داخلي، لـ SDK الأصلي). auth.weburl يتطلب بيانات اعتماد المنصة المفتوحة.',
		poc_title: 'إثبات توافق HFLV',
		poc_intro: 'التحقق من قدرة flv.js + المتصفح على HFLV',
		poc_intro_desc: 'التحقق من توافق المتصفح / Capacitor WebView باستخدام دفقات اختبار عامة.',
		test_stream: 'دفق الاختبار',
		play: 'تشغيل',
		stop: 'إيقاف',
		reload: 'إعادة تحميل',
		logs: 'السجلات',
		missing_sn: 'الجهاز يفتقد SN، تعذر التشغيل',
	},
	scan: {
		browser_supported: 'المسح متاح في هذا المتصفح',
		browser_unsupported: 'هذا المتصفح لا يدعم المسح',
		browser_supported_desc: 'يمكن للويب استخدام BarcodeDetector عند دعم المتصفح؛ وسيستخدم تطبيق الجوال المسح الأصلي بالكاميرا.',
		browser_unsupported_desc: 'استخدم تطبيق الجوال أو متصفحا متوافقا مع مسح الكاميرا.',
		capacitor_plan: 'سيستخدم تطبيق iOS / Android المسح الأصلي؛ وتعرض صفحة الويب حالة التوافق فقط.',
		start_scan: 'بدء المسح',
	},
	modules: {
		dashboard: 'لوحة المعلومات',
		device: 'الأجهزة',
		store: 'المتجر',
		live: 'الفيديو المباشر',
		event: 'مركز الأحداث',
		alert: 'التنبيهات',
		inspect: 'الفحص',
		patrol: 'الدورية',
		leavepost: 'خارج المنصب',
		customer: 'تحليل العملاء',
		traffic: 'إحصاءات حركة المرور',
		heatmap: 'الخريطة الحرارية',
		pos: 'تراكب نقاط البيع',
		scan: 'مسح ضوئي',
		auth: 'تسجيل الدخول',
		member: 'الأعضاء',
		evaluation: 'التقييم',
		wechatvip: 'WeChat VIP',
		figurewarning: 'تنبيه بشري',
		university: 'جامعة Ulucu',
		staff: 'الموظفون',
		guard: 'الحراسة',
		message: 'الرسائل',
		rewardpunish: 'المكافآت والعقوبات',
		smartlistening: 'الاستماع الذكي',
		cloudstorage: 'التخزين السحابي',
		phonelive: 'البث من الهاتف',
		sharedevice: 'الأجهزة المشتركة',
		datawarn: 'تنبيهات البيانات',
		aipatrol: 'فحص بالذكاء الاصطناعي',
		reportaudit: 'مراجعة التقارير',
	},
	reportaudit: {
		title: 'مراجعة التقارير',
		tab: { audit: 'مراجعة', self: 'فحص ذاتي' },
		filter: { store: 'المتجر', date: 'التاريخ', status: 'الحالة', template: 'القالب' },
		status: { pending: 'قيد المراجعة', passed: 'مجتاز', rejected: 'مرفوض' },
	},
	changelog: {
		unread: 'جديد',
		load_more: 'تحميل المزيد',
		no_more: '— لا مزيد —',
	},
	album: {
		empty: 'لا توجد لقطات',
		local: 'اللقطات المحلية',
		edit: 'تحرير',
		delete: 'حذف',
		deleted: 'تم الحذف',
		delete_failed: 'فشل الحذف',
		select_first: 'اختر أولاً',
		selected_n: '{{n}} محدد',
		confirm_delete: 'حذف {{n}} لقطة محددة؟',
		load_more: 'تحميل المزيد',
		no_more: '— لا مزيد —',
	},
	aipatrol: {
		title: 'فحص بالذكاء الاصطناعي',
		banner_title: 'فحص ذكي',
		banner_subtitle: 'كشف الشذوذ 24/7 — بدون جولات يدوية',
		unnamed_model: 'نموذج بلا اسم',
		sec: { pic: 'صورة AI', video: 'فيديو AI', other: 'أخرى' },
		app: {
			datacenter: 'مركز البيانات',
			stats: 'إحصائيات',
			report: 'تقارير',
			leavepost: 'مغادرة المركز',
			gallery: 'المعرض',
			alert: 'تنبيهات',
		},
		dc: {
			title: 'مركز البيانات',
			fav: 'المفضلة',
			last7d: 'آخر 7 أيام',
			all_stores: 'كل المتاجر',
			all_models: 'كل النماذج',
			load_more: 'اضغط أو اسحب لتحميل المزيد',
			no_more: '— لا مزيد —',
		},
		kpi: { stores: 'المتاجر المفعّلة', devices: 'الأجهزة المفعّلة' },
		alarm: {
			title_yesterday: 'إنذارات الأمس',
			count_label: 'العدد',
			load_more: 'تحميل المزيد',
			latest: 'أحدث الإنذارات',
		},
		stats: {
			title: 'إحصائيات',
			last7d: 'آخر 7 أيام',
			all_tasks: 'كل المهام',
			all_stores: 'كل المتاجر',
			all_users: 'كل المفتشين',
			violation_total: 'إجمالي المخالفات',
			violation_type_count: 'أنواع المخالفات',
			store_total: 'المتاجر المختارة',
			patroller_count: 'المفتشون',
			report_submit_count: 'التقارير المرسلة',
			trend: 'اتجاه المتجر',
			dim_day: 'يوم',
			dim_month: 'شهر',
			rank: 'ترتيب المخالفات',
			view_more: 'عرض المزيد',
			col_item: 'البند',
			col_count: 'العدد',
			col_stores: 'المتاجر',
		},
	},
	rep: {
		title: 'التقارير',
		dash: '–',
		last_7d: 'آخر 7 أيام',
		today: 'اليوم',
		no_content: 'لا يوجد محتوى',
		unit: { person: '', percent: '%', yuan: 'CNY' },
		cust: {
			title: 'تحليل العملاء',
			this_month: 'هذا الشهر',
			gdrs: 'المارة',
			jdkl: 'الداخلون',
			jzkl: 'دخول دقيق',
			jdzhl: 'معدل الدخول',
			xsze: 'الإيرادات',
		},
		youxun: {
			title: 'يوشون',
			alarm_count: 'التنبيهات',
			most_store: 'أعلى متجر',
			times: '',
			none: '—',
		},
		xdt: {
			title: 'تشيندينتونغ',
			unit: '',
			examine_submit: 'مرسل',
			examine_waiting: 'قيد المراجعة',
			examine_today: 'مهام اليوم',
			inspect_submit: 'فحص ذاتي',
			inspect_waiting: 'مراجعة الفحص',
			inspect_today: 'اليوم',
			dj_handled: 'تم',
			dj_waiting: 'معلق',
			dj_expired: 'متأخر',
		},
		event: {
			title: 'الأحداث',
			total: 'الإجمالي',
			pending: 'معلق',
			key: 'النوع الرئيسي',
			unit: '',
			none: '—',
		},
		editor: {
			btn: 'إعادة ترتيب',
			title: 'إعادة ترتيب وإضافة',
			cancel: 'إلغاء',
			ok: 'تم',
			advanced: 'إعدادات متقدمة',
			shown: 'الوحدات المعروضة',
			available: 'وحدات متاحة',
		},
		advanced: {
			title: 'يوشون متقدم',
			search_ph: 'ابحث باسم النموذج أو المعرف',
			counter: 'المشتركة {{picked}} / {{total}}',
			saved: 'تم الحفظ',
			save_failed: 'فشل الحفظ',
		},
	},
	mselect: {
		title: 'اختر الأجهزة للعرض',
		search_ph: 'ابحث عن جهاز',
		counter: '{{online}} متصل · {{picked}} محدد',
		no_online: 'لا توجد أجهزة متصلة',
		watch: 'عرض',
	},
	vfilter: {
		title: 'تصفية',
		device: 'أجهزة المتجر',
		has_dev: 'به جهاز',
		no_dev: 'بدون جهاز',
		status: 'حالة الجهاز',
		online: 'متصل',
		offline: 'غير متصل',
		fav_status: 'المفضلة',
		faved: 'مفضل',
		unfaved: 'غير مفضل',
		sort: 'ترتيب حسب',
		sort_create: 'الأحدث',
		sort_name: 'أ → ي',
		reset: 'إعادة',
		ok: 'تطبيق',
	},
	sov: {
		compare: 'مقارنة',
		rank_title: 'ترتيب المتجر',
		b_avg: 'متوسط الشركة',
		exceed: 'يتفوق على {{pct}}% من المتاجر',
		avg: 'المتوسط',
		settings_title: 'إعدادات بيانات المتجر',
		selected_data: 'المقاييس المختارة',
		selected_hint: 'اسحب لإعادة الترتيب',
		done: 'تم',
		saved: 'تم الحفظ',
		save_failed: 'فشل الحفظ',
		cat: {
			business: 'الأعمال',
			traffic: 'حركة العملاء',
			event: 'الإدارة',
		},
		p: {
			hour: 'ساعة',
			day: 'يوم',
			week: 'أسبوع',
			month: 'شهر',
			quarter: 'ربع',
		},
		t: {
			jzkl: 'دخول دقيق',
			gdrs: 'المارة',
			gdrs_f: 'المارة (F)',
			jdzhl: 'معدل الدخول',
			xfds: 'الطلبات',
			xsze: 'الإيرادات',
			cjl: 'معدل الصفقة',
			sjzs: 'الأحداث',
			dclsjs: 'أحداث معلقة',
			zkl: 'إجمالي الزيارات',
			jtlsc: 'متوسط البقاء (د)',
			kdj: 'متوسط الفاتورة',
			ldl: 'عناصر/طلب',
		},
	},
	native: {
		common: {
			all: 'الكل',
			clear: 'مسح',
			date: 'التاريخ',
			phone: 'الهاتف',
			remove_picture: 'إزالة الصورة',
			submit: 'إرسال',
			view_all: 'عرض الكل',
			back: 'رجوع',
			cancel: 'إلغاء',
			complete: 'إتمام',
			confirm: 'تأكيد',
			copy: 'نسخ',
			default: 'افتراضي',
			details: 'التفاصيل',
			edit: 'تعديل',
			filter: 'تصفية',
			from_high_to_low: 'من الأعلى إلى الأدنى',
			level: 'المستوى',
			no_content: 'لا يوجد محتوى',
			no_data: 'لا توجد بيانات',
			online: 'متصل',
			offline: 'غير متصل',
			operation_failed: 'فشلت العملية',
			organization: 'المؤسسة',
			people: 'أشخاص',
			pcs: 'قطعة',
			picture: 'صورة',
			refresh: 'تحديث',
			reset: 'إعادة ضبط',
			save: 'حفظ',
			search: 'بحث',
			search_by_store_name: 'البحث باسم المتجر',
			search_history: 'سجل البحث',
			store: 'المتجر',
			video: 'فيديو',
			all_stores: 'كل المتاجر',
			all_status: 'كل الحالات',
			all_tasks: 'كل المهام',
			all_executors: 'كل المنفذين',
		},
		settings: {
			title: 'الإعدادات',
			modify_password: 'تعديل كلمة المرور',
			language_setting: 'إعداد اللغة',
			clear_cache: 'مسح الذاكرة المؤقتة',
			clear_cache_confirm: 'هل تريد مسح الذاكرة المؤقتة؟',
			about_us: 'من نحن',
			logout: 'تسجيل الخروج',
			old_password: 'كلمة المرور القديمة',
			new_password: 'كلمة المرور الجديدة',
			confirm_password: 'تأكيد كلمة المرور',
		},
		profile: {
			my_album: 'ألبومي',
			watch_history: 'سجل المشاهدة',
			online_repair: 'طلب صيانة',
			repair_record: 'سجل الصيانة',
			setting: 'الإعدادات',
		},
		home: {
			title: 'الرئيسية',
			latest_news: 'آخر الأخبار',
			assessment: 'التقييم',
			today: 'اليوم',
			assessment_empty: 'لا يوجد محتوى',
			submitted: 'إرسال التقييم',
			waiting_approve: 'بانتظار الموافقة',
			event: 'الحدث',
			recent_7_days: 'آخر 7 أيام',
			events: 'الأحداث',
			pending_events: 'الأحداث قيد المعالجة',
			key_type: 'نوع الحدث الرئيسي',
			ranking: 'الترتيب والعرض',
			organization: 'المؤسسة',
			message: 'مركز الرسائل',
			system_message: 'رسالة النظام',
			event_message: 'رسالة الحدث',
			evaluation_message: 'رسالة التقييم',
			store_inspection_message: 'رسالة تفتيش المتجر',
			no_new_message: 'لا توجد رسائل جديدة',
			new_message: 'رسالة جديدة',
			no_latest_news: 'لا توجد أخبار حديثة',
			last_update: 'آخر تحديث:',
			no_data_last_2_days: 'لا توجد بيانات في آخر يومين~',
			management: 'الإدارة',
			statistics: 'الإحصاءات',
			report: 'التقرير',
			my_assessment: 'تقييمي',
			audits: 'التدقيقات',
			draft_box: 'المسودات',
			report_status: 'حالة التقرير',
			template: 'القالب',
			pending: 'قيد الانتظار',
			to_be_accepted: 'بانتظار القبول',
			processed: 'تمت المعالجة',
			expired: 'منتهي',
			deleted: 'محذوف',
			total_events: 'إجمالي الأحداث',
			event_types: 'أنواع الأحداث',
			message_content_aria: 'محتوى الرسالة',
			message_aria: 'رسالة',
			create_event: 'إنشاء حدث',
			submit: 'إرسال',
			select_store: 'اختيار المتجر',
			please_choose_store: 'يرجى اختيار المتجر',
			please_choose_event_type: 'يرجى اختيار نوع الحدث',
			event_scoring: 'تقييم الحدث',
			priority: 'الأولوية',
			assign_to: 'إسناد إلى',
			follower: 'المتابعون',
			remarks_placeholder: 'ملاحظات بحد أقصى 3000 حرف',
			add_3_pictures: 'أضف 3 صور كحد أقصى',
			confirm: 'تأكيد',
			select_all: 'تحديد الكل',
			store_name: 'اسم المتجر',
			name: 'الاسم',
			please_input_key_words: 'يرجى إدخال كلمات البحث',
			please_input_key_words_title: 'يرجى إدخال كلمات البحث',
			choose_store_required: 'يرجى اختيار المتجر',
			choose_event_type_required: 'يرجى اختيار نوع الحدث',
			priority_source_pending: 'بيانات الأولوية غير جاهزة',
			scoring_required: 'يرجى اختيار تقييم الحدث',
			property_required: 'يرجى اختيار بند التقييم',
			choose_assignor_required: 'يرجى اختيار المسؤول',
			picture_required: 'يرجى اختيار أو إضافة صورة',
			event_created: 'تم الإنشاء بنجاح',
			choose_store_first: 'يرجى اختيار المتجر أولاً',
			please_select_assignor: 'يرجى اختيار المسؤول',
			please_select_follower: 'يرجى اختيار المتابع',
			select_assignor: 'اختيار المسؤول',
		},
		application: {
			title: 'التطبيقات',
			display_title: 'الترتيب والعرض',
			display_subtitle: 'وحدة عرض صفحة التطبيقات',
			fixed: 'مثبت',
			saved: 'تم حفظ عرض التطبيقات',
			reset_done: 'تمت استعادة الترتيب الافتراضي',
			last_visible: 'أبق تطبيقا واحدا مرئيا على الأقل',
			move_up: 'نقل لأعلى',
			move_down: 'نقل لأسفل',
			show: 'إظهار',
			hide: 'إخفاء',
			function_intro: 'مقدمة الوظيفة',
			permission_denied: 'ليست لديك صلاحية استخدام هذه الوحدة.',
			groups: {
				store: 'رقمنة المتجر',
				standard: 'إدارة موحدة',
				marketing: 'تسويق ذكي',
				data: 'مركز البيانات',
			},
			items: {
				customer_flow_analysis: 'تحليل تدفق العملاء',
				traffic_flow: 'تدفق المرور',
				heat_map: 'خريطة حرارية',
				event: 'حدث',
				shake_inspection: 'تفتيش سريع',
				off_duty_patro: 'تفتيش مغادرة الموقع',
				timed_inspection: 'تفتيش مجدول',
				timed_snapshot_inspection: 'تفتيش لقطات مجدول',
				assessment: 'تقييم',
				qr_code_scan_superposition: 'تراكب مسح رمز QR',
				intelligent_attendance: 'حضور ذكي',
				reward_punish: 'مكافأة وعقوبة',
				smart_listening: 'استماع ذكي',
				shopping_guide: 'دليل التسوق',
				intelligent_classroom: 'فصل ذكي',
				customer_flow_alert: 'تنبيه تدفق العملاء',
				ranking_display: 'الترتيب والعرض',
				phone_live: 'بث الهاتف',
				smart_marketing: 'تسويق ذكي',
				data_center: 'مركز البيانات',
				cloud_storage: 'تخزين سحابي',
			},
		},
		store: {
			device_list: 'قائمة الأجهزة',
			data: 'البيانات',
			access_camera: 'الوصول إلى الكاميرا',
			repair_record: 'سجل الصيانة',
			store_creation_time: 'وقت إنشاء المتجر',
			camera_setting: 'إعدادات الكاميرا',
			device_layout_preview: 'عرض المعاينة',
			device_layout_list: 'عرض القائمة',
			device_is_offline: 'الجهاز غير متصل',
			offline_time: 'وقت عدم الاتصال',
			offline_duration: 'مدة عدم الاتصال',
			setting_unavailable: 'هذا الإعداد غير متاح على الويب بعد.',
			camera_name: 'اسم الكاميرا',
			cloud_storage: 'تخزين سحابي',
			local_storage: 'تخزين محلي',
			connect_other_wifi: 'الاتصال بشبكة Wi-Fi أخرى',
			no_longer_use: 'إيقاف الاستخدام',
			connect_camera_to_store: 'صل الكاميرا بمتجرك',
			compared_previous: 'مقارنة بالفترة السابقة',
			events: 'الأحداث',
			events_to_be_processed: 'الأحداث قيد المعالجة',
			data_ranking: 'ترتيب بيانات المتجر',
			store_data_setting: 'إعداد بيانات المتجر',
			data_selected_hint: 'البيانات المحددة (اضغط مطولاً واسحب لضبط الترتيب)',
			manage_data: 'إدارة البيانات',
			max_metrics: 'اختر حتى {{count}} مؤشرات',
			keep_one_metric: 'احتفظ بمؤشر واحد على الأقل',
			chart_visibility: 'عرض المخطط',
			average: 'المتوسط',
			compared_previous_range: '(مقارنة بالفترة السابقة{{range}})',
			ranking_detail_with_unit: 'متوسط المؤسسة {{average}}{{unit}}، تتجاوز {{exceed}}% من المتاجر',
			period_hour: 'ساعة',
			period_day: 'يوم',
			period_week: 'أسبوع',
			period_month: 'شهر',
			period_quarter: 'ربع سنوي',
			full_storage: 'تخزين كامل',
			mobile_detection_storage: 'تخزين كشف الحركة',
			set_storage_schedule: 'تعيين جدول التخزين',
			entry_number: 'عدد الدخول',
			pieces: '{{count}} قطعة',
			ranking_detail: 'متوسط المؤسسة {{average}} قطعة، تتجاوز {{exceed}} من المتاجر',
			cloud_storage_banner_auto_detect: 'كشف تلقائي، تخزين سحابي',
			cloud_storage_banner_look_back: 'الرجوع في أي وقت',
			cloud_storage_banner_encryption: 'تشفير صارم وأمان',
			cloud_storage_unavailable_line1: 'خدمة التخزين السحابي للجهاز',
			cloud_storage_unavailable_line2: 'غير متاحة بعد.',
			contact_administrator: 'يرجى التواصل مع المسؤول.',
			memory_card_recording: 'تشغيل تسجيل بطاقة الذاكرة',
			memory_card_type: 'اختيار نوع بطاقة الذاكرة',
			internal_storage_space: 'مساحة التخزين الداخلية',
			storage_available: 'متاح {{value}}',
			storage_total: 'الإجمالي {{value}}',
			format_memory_card: 'تهيئة بطاقة الذاكرة',
			storage_status_normal: 'طبيعي',
			memory_card_format_hint: 'بعد التهيئة، سيتم استخدام جزء من مساحة بطاقة الذاكرة لتخزين ملفات النظام، وقد تكون السعة المتبقية المعروضة أقل من الحجم الفعلي للبطاقة.',
			memory_card_non_standard_tip: 'تنبيه: بطاقة الذاكرة هذه غير قياسية. يرجى استخدام بطاقة قياسية لحماية بياناتك.',
		},
		repair: {
			add_picture: 'إضافة صورة',
			fault_tip: 'يرجى وصف العطل وخطوات التشغيل ذات الصلة كي يتمكن المهندس من حله في أقرب وقت.',
			pictures_tip: 'يرجى رفع صور ذات صلة كمرجع لحل المشكلة بكفاءة.',
			record: 'سجل الصيانة',
			date_range: 'نطاق التاريخ',
			status_submitted: 'تم الإرسال',
			status_processing: 'قيد المعالجة',
			repair_no: 'رقم طلب الصيانة',
			select_store: 'اختر المتجر',
			contact_person: 'جهة الاتصال',
			contact_number: 'رقم الاتصال',
			tel: 'هاتف',
			store_prefix: 'المتجر',
			fault_description: 'وصف العطل',
			submission_time: 'وقت الإرسال',
			images: 'الصور',
			no_images: 'لا توجد صور',
		},
		snapshot: {
			timed_snapshot_inspection: 'Timed Snapshot Inspection',
			inspection_task: 'Inspection Task',
			create_inspection: 'Create Inspection',
			start_date: 'Start Date',
			end_date: 'End Date',
			load_failed: 'Load failed',
			apac_only: 'Timed Snapshot Inspection is only connected for APAC.',
			all_unprocessed: 'All Unprocessed',
			task_status: 'Task Status',
			enabled: 'Enabled',
			disabled: 'Closed',
			plan_opened_success: 'Plan opened successfully',
			plan_closed_success: 'Plan closed successfully',
			plan_status_failed: 'Plan status update failed',
			delete_task: 'Delete task',
			delete_success: 'Deleted successfully',
			delete_failed: 'Delete failed',
			today_screenshots: 'Today Screenshots',
			today_processed: 'Today Processed',
			total_unprocessed: 'Total Unprocessed',
			total_unqualified: 'Total Unqualified',
			task_store: 'Task Store',
			stores_suffix: 'Stores',
			executor: 'Executor',
			people_suffix: 'People',
			task_time: 'Task Time',
			execution_cycle: 'Execution Cycle',
			task_name: 'Task Name',
			detail_information: 'Detail Information',
			execution_date: 'Execution Date',
			execution_month: 'Execution Month',
			assessment_template: 'Assessment Template',
			select_template: 'Select template',
			store: 'Store',
			select_executor: 'Select executor',
			device_point: 'Device',
			select_device: 'Select device',
			execution_time: 'Execution Time',
			add_time: 'Add time',
			validation_template: 'Please select an assessment template',
			save_success: 'Saved successfully',
			save_failed: 'Save failed',
			qualified: 'Qualified',
			unqualified: 'Unqualified',
			process_success: 'Processed successfully',
			process_failed: 'Process failed',
			mon: 'Mon',
			tues: 'Tues',
			wed: 'Wed',
			thur: 'Thur',
			fri: 'Fri',
			sat: 'Sat',
			sun: 'Sun',
			inspection_statistics: 'إحصاءات التفتيش',
			inspection_data: 'بيانات التفتيش',
			store_data_statistics: 'إحصاءات بيانات المتجر',
			executor_statistics: 'إحصاءات المنفذ',
			all_planned_screenshot: 'كل اللقطات المخططة',
			current_screenshot: 'اللقطات الحالية',
			current_processed: 'المعالج حاليا',
			overdue_unprocessed: 'متأخر غير معالج',
			maximum_violations: 'أعلى مخالفات',
			minimum_violations: 'أقل مخالفات',
			account: 'الحساب',
			full_name_role: 'الاسم الكامل (الدور)',
			to_be_processed: 'قيد المعالجة',
			processed: 'تمت المعالجة',
			rank: 'الرتبة',
			ranking_all_stores: 'ترتيب كل المتاجر',
			total_violations: 'إجمالي المخالفات',
			ranking: 'الترتيب',
			violation_items_ranking: 'ترتيب عناصر المخالفات',
			items_name: 'اسم العنصر',
			violation_numbers: 'عدد المخالفات',
			percentage: 'النسبة',
			daily_violation_item: 'اتجاه المخالفات اليومي (حسب العنصر)',
			daily_violation_store: 'اتجاه المخالفات اليومي (حسب المتجر)',
		},
		evaluation: {
			management: 'الإدارة',
			store: 'المتجر',
			by_score: 'حسب الدرجة',
			by_store: 'حسب المتجر',
			select_task: 'اختر مهمة',
			select_store: 'اختر متجر',
			select_user: 'اختر مستخدما',
			select_stores_count: 'اختر({{count}}) متاجر',
			select_tasks_count: 'اختر({{count}}) مهام',
			search_store: 'ابحث عن متجر',
			deselect_all: 'إلغاء تحديد الكل',
			keyword_placeholder: 'يرجى إدخال كلمة مفتاحية',
			user_keyword_placeholder: 'يرجى إدخال كلمات مفتاحية...',
			expired_tasks: 'Expired Tasks',
			no_tasks_in_progress: 'No tasks in progress',
			select_date: 'Select Date',
			today: 'Today',
			recent_7_days: 'Recent 7 Days',
			recent_30_days: 'Recent 30 Days',
			recent_90_days: 'Recent 90 Days',
			recent_180_days: 'Recent 180 Days',
			customize: 'Customize',
			start_date: 'Start Date',
			end_date: 'End Date',
			select_user_count: 'Select({{count}})User',
			select_templates_count: 'Select({{count}})Templates',
			please_select: 'Please Select',
			please_input: 'Please input',
			please_input_keywords: 'Please Input Key Words',
			store_name: 'Store Name',
			name: 'Name',
			select_all: 'Select All',
			location_permission: 'تحتاج إلى تفعيل إذن الموقع للحصول على المتاجر القريبة',
			reviewer: 'المراجع',
			submitter: 'المرسل',
			title: 'التقييم',
			report: 'Report',
			my_assessment: 'My Assessment',
			audits: 'Audits',
			draft_box: 'Draft Box',
			date: 'Date',
			report_status: 'Report Status',
			template: 'Template',
			assessment_details: 'Assessment Details',
			assessment_time: 'Assessment Time',
			score: 'Score',
			assessment_task: 'Assessment Task',
			source: 'Source',
			assessment_content: 'Assessment Content',
			filter_full_score_item: 'Filter Full Score Item',
			standard: 'Standard',
			qualified: 'Qualified',
			unqualified: 'Unqualified',
			passed: 'Passed',
			failed: 'Failed',
			remarks: 'Remarks',
			no_picture: 'No picture',
			no: 'No',			assessment_today: 'تقييم اليوم',
			assigned_to_me: 'مسند إلي',
			remote_assessment: 'تقييم عن بعد',
			onsite_assessment: 'تقييم ميداني',
			my_task: 'مهمتي',
			ranking: 'الترتيب',
			task_progress: 'تقدم المهمة:',
		},
		inspect: {
			empty: 'لم تقم بإضافة خطة تفتيش متجر بعد~',
			add_plan: 'إضافة خطة',
			title: 'تفتيش مجدول',
			add_title: 'إضافة خطة',
			plan: 'الخطة',
			plan_name: 'اسم الخطة',
			select_store: 'اختيار المتجر',
			select_device: 'اختيار الجهاز',
			equipment_location: 'موقع الجهاز',
			store_inspection_time: 'وقت تفتيش المتجر',
			set_time: 'تعيين وقت تفتيش المتجر',
			submit_plan: 'إرسال الخطة',
			confirm: 'تأكيد',
			cancel: 'إلغاء',
			select_all: 'اختيار الكل',
			store_name: 'اسم المتجر',
			equipment_name: 'اسم الجهاز',
			search_keywords: 'يرجى إدخال كلمات مفتاحية',
			equipment_search: 'بحث الجهاز',
			no_stores: 'لا توجد متاجر',
			no_devices: 'لا توجد أجهزة',
			store_count: 'عدد المتاجر المفتشة',
			stores: 'متاجر',
			inspection_time: 'وقت تفتيش المتجر',
			running_state: 'حالة التشغيل',
			executing: 'قيد التنفيذ',
			closed: 'مغلق',
			detail_title: 'تفاصيل خطة تفتيش المتجر',
			update_time: 'وقت التحديث',
			enabled: 'ممكّن',
			off_state: 'متوقف',
			intelligent: 'ذكي',
			time: 'الوقت',
			no_data: 'لا توجد بيانات',
			refresh: 'تحديث',
			plan_opened_success: 'تم فتح الخطة بنجاح',
			plan_closed_success: 'تم إغلاق الخطة بنجاح',
			plan_status_failed: 'فشل تحديث حالة الخطة',
			picture_preview: 'معاينة الصورة',
			picture_load_failed: 'فشل تحميل الصور',
			create_event: 'إنشاء حدث',
			download_picture: 'تنزيل الصورة',
			intelligent_options: 'الخيارات الذكية',
			intelligent_options_title: 'يرجى اختيار الخيارات الذكية لفحص المتجر',
			intelligent_option_roughly: 'هذا المكان مطابق تقريبًا',
			intelligent_options_learning: 'معرفة المزيد عن الخيارات الذكية...',
			intelligent_options_tip: 'تلميح: بعد تفعيل الخيارات الذكية، سيتم عرض صور فحص المتجر التي لا تستوفي الخيارات بشكل منفصل. ومع ذلك، إذا انحرفت الكاميرا، فقد تكون النتيجة غير دقيقة أو غير صالحة. عندها يمكن إعادة ضبط الخيارات الذكية لهذا الموقع.',
			choose_later: 'الاختيار لاحقًا',
			device_context_missing: 'معلومات الجهاز غير متاحة',
			message_context_missing: 'معلومات الرسالة غير متاحة',
			picture_unavailable: 'الصورة غير متاحة',
			add_success: 'تمت إضافة الخطة بنجاح',
			delete: 'حذف',
			delete_confirm_title: 'حذف الخطة',
			delete_confirm_body: 'هل تريد حذف خطة التفتيش المجدولة؟',
			delete_success: 'تم حذف الخطة',
			delete_failed: 'فشل الحذف',
			load_failed: 'فشل تحميل خطط التفتيش المجدولة',
			submit_failed: 'فشل الإرسال',
			validation_plan_name: 'يرجى إدخال اسم الخطة',
			validation_store: 'يرجى اختيار متجر',
			validation_device: 'يرجى اختيار جهاز',
			validation_time: 'يرجى اختيار وقت التفتيش',
			validation_user: 'معرف المستخدم الحالي مفقود',
			validation_item: 'بيانات عنصر التفتيش غير مكتملة',
			hour: 'ساعة',
			minute: 'دقيقة',
			time_slot_1: 'يرجى اختيار وقت التفتيش الأول',
			time_slot_2: 'يرجى اختيار وقت التفتيش الثاني',
			time_slot_3: 'يرجى اختيار وقت التفتيش الثالث',
			time_slot_4: 'يرجى اختيار وقت التفتيش الرابع',
			time_slot_5: 'يرجى اختيار وقت التفتيش الخامس',
			time_slot_6: 'يرجى اختيار وقت التفتيش السادس',
			time_slot_7: 'يرجى اختيار وقت التفتيش السابع',
			time_slot_8: 'يرجى اختيار وقت التفتيش الثامن',
			time_slot_9: 'يرجى اختيار وقت التفتيش التاسع',
			time_slot_10: 'يرجى اختيار وقت التفتيش العاشر',
		},
	},
};
